import React from "react"
import {Button, Divider} from "@heroui/react"
import {IconLock, IconArrowRight} from "@tabler/icons-react"

interface FeatureUnavailableMessageProps {
  title: string
  description: string
  contactEmail?: string
}

export const FeatureUnavailableMessage: React.FC<
  FeatureUnavailableMessageProps
> = ({title, description, contactEmail = "ben@obsidianlabs.co"}) => {
  return (
    <div className="mb-6 overflow-hidden rounded-lg border border-neutral-200 bg-white shadow-sm">
      <div className="flex items-center gap-4 p-4">
        <div className="rounded-full bg-neutral-100 p-3">
          <IconLock className="h-6 w-6 text-neutral-400" />
        </div>
        <div className="flex-1">
          <h3 className="text-lg font-semibold text-neutral-800">
            {title} Not Enabled
          </h3>
          <p className="mt-1 text-neutral-500">
            {/* Unlock this feature by upgrading your account */}
            {description}
          </p>
        </div>
        {/* <Divider orientation="vertical" className="h-12" /> */}
        <Button
          color="primary"
          size="md"
          radius="md"
          className="font-medium"
          endContent={<IconArrowRight className="h-4 w-4" />}
          onClick={() => window.open(`mailto:${contactEmail}`)}
        >
          Contact Sales
        </Button>
      </div>
    </div>
  )
}
